import { useEffect } from "react";
import { WithTranslation, withTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { Box } from "rebass/styled-components";
import { RootState, ThunkDispatch } from "core-integration/src/store";
import { getCode } from "core-integration/src/store/leagues/reducers";
import {
  fetchLeagueCode,
  regenerateLeagueCode,
} from "core-integration/src/store/leagues/thunks";
import { IPrivateLeagueAdmin } from "core-integration/src/store/leagues/types";
import Button from "../../Button";

interface IOwnProps {
  league: IPrivateLeagueAdmin;
}

type Props = IOwnProps & WithTranslation;

const Code = ({ league, t }: Props) => {
  const dispatch = useDispatch<ThunkDispatch>();
  const code = useSelector((state: RootState) => getCode(state, league.id));

  useEffect(() => {
    if (!league.closed) {
      dispatch(fetchLeagueCode(league.id));
    }
  }, []);

  if (league.closed) {
    return null;
  }
  return (
    <>
      <p>
        {t("leagues.code", "League code")}: {code}
      </p>
      <Box mb={4}>
        <Button onClick={() => dispatch(regenerateLeagueCode(league.id))}>
          {t("leagues.regenerateButton", "Regenerate")}: {code}
        </Button>
      </Box>
    </>
  );
};

export default withTranslation()(Code);
